import { useQuery } from '@tanstack/react-query'
import axiosInstance from '@/core/api'

type TurnoverStatus = {
	hasActiveTurnover: boolean
	turnoverAmount: number
	balance: number
}

export function useQueryPlayerTurnover(playerId?: string | null) {
	return useQuery({
		queryKey: ['player-turnover', playerId],
		queryFn: async () => {
			const { data } = await axiosInstance.get<TurnoverStatus>(
				`/admin/bank-transactions/players/${playerId}/turnover-status`,
			)
			return data
		},
		enabled: !!playerId,
		staleTime: 10_000,
	})
}
